import { Target } from 'lucide-react';

const BASELINES = [
  { id: 1, name: 'CIS Ubuntu 22.04 L1', category: 'OS Hardening', compliance: '94%', status: 'active', lastAudit: '2026-05-10' },
  { id: 2, name: 'CIS Windows Server 2022 L1', category: 'OS Hardening', compliance: '88%', status: 'active', lastAudit: '2026-05-09' },
  { id: 3, name: 'NIST 800-53 Firewall Rules', category: 'Network', compliance: '97%', status: 'active', lastAudit: '2026-05-11' },
  { id: 4, name: 'PCI-DSS Database Config', category: 'Database', compliance: '91%', status: 'draft', lastAudit: '—' },
  { id: 5, name: 'SOC2 Access Control', category: 'IAM', compliance: '82%', status: 'active', lastAudit: '2026-05-08' },
  { id: 6, name: 'ISO 27001 Endpoint Baseline', category: 'Endpoint', compliance: '76%', status: 'archived', lastAudit: '2026-04-15' },
];

const STATUS_STYLES = {
  active: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
  draft: 'bg-amber-500/20 text-amber-400 border-amber-500/30',
  archived: 'bg-gray-500/20 text-gray-400 border-gray-500/30',
};

const BaselineManagement = () => (
  <div className="p-6 space-y-6">
    <div className="mb-6">
      <h1 className="text-2xl font-bold text-white">Baseline Management</h1>
      <p className="text-sm text-gray-500 mt-1">
        Define the &quot;Golden Baseline&quot; for the network · PRD: DRIFT-01 (Section 7.7)
      </p>
    </div>

    <div className="bg-gray-900 border border-gray-700/50 rounded-xl p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <Target className="w-5 h-5 text-cyan-400" />
          <h2 className="text-lg font-semibold text-white">Baseline Configurations</h2>
        </div>
        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-cyan-500/20 text-cyan-400 border border-cyan-500/30">
          Coming Soon
        </span>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-gray-500 uppercase text-xs border-b border-gray-700/50">
              <th className="text-left py-3 pr-4 font-medium">Baseline Name</th>
              <th className="text-left py-3 pr-4 font-medium">Category</th>
              <th className="text-left py-3 pr-4 font-medium">Compliance</th>
              <th className="text-left py-3 pr-4 font-medium">Status</th>
              <th className="text-left py-3 font-medium">Last Audit</th>
            </tr>
          </thead>
          <tbody className="text-gray-400">
            {BASELINES.map((bl) => (
              <tr key={bl.id} className="border-b border-gray-800/50 hover:bg-gray-800/30 transition-colors">
                <td className="py-3 pr-4">
                  <div className="flex items-center gap-2">
                    <Target className="w-3.5 h-3.5 text-gray-600" />
                    <span className="text-white font-medium">{bl.name}</span>
                  </div>
                </td>
                <td className="py-3 pr-4">
                  <span className="px-2 py-0.5 rounded text-xs font-mono bg-gray-800 text-gray-300">{bl.category}</span>
                </td>
                <td className="py-3 pr-4">
                  <div className="flex items-center gap-2">
                    <div className="w-20 h-1.5 bg-gray-800 rounded-full overflow-hidden">
                      <div
                        className={`h-full rounded-full ${
                          parseInt(bl.compliance) >= 90 ? 'bg-emerald-400' :
                          parseInt(bl.compliance) >= 80 ? 'bg-amber-400' : 'bg-red-400'
                        }`}
                        style={{ width: bl.compliance }}
                      />
                    </div>
                    <span className="font-mono text-xs">{bl.compliance}</span>
                  </div>
                </td>
                <td className="py-3 pr-4">
                  <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${STATUS_STYLES[bl.status]}`}>
                    {bl.status}
                  </span>
                </td>
                <td className="py-3 font-mono text-xs text-gray-500">{bl.lastAudit}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default BaselineManagement;
